<template>
    <b-button variant="primary" @click.stop="confirmar()" v-if="mostrarBtn">
        <span>
            <i class="fa fa-arrow-circle-right"></i> Enviar para análise
        </span>
    </b-button>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: `Consultoria`,
                html: 'Confirma o envio da consultoria para análise?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviar()
                }
            })
        },

        enviar() {
            this.$store.dispatch('addRequest')
            let envioDto = {
                consultoriaId: this.$route.params.consultoriaId
            }
            this.services
                .enviarConsultoriaParaAnalise(envioDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Envio realizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterConsultoriaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao processar o envio para análise',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-02') &&
                this.consultoria.temRaht &&
                this.consultoria.temAnexo &&
                (this.consultoria.status === consultoriaStatus.EM_ANDAMENTO ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_ANALISE ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_CORRECAO)
            )
        }
    }
}
</script>
